import React, { Component } from 'react';
import classNames from 'classnames';
import { REACT_APP_API_BASE } from '../../config';
import SpinnerDots from '../../components/spinner/dots';
import withAuthProvider from '../../hoc/withAuthProvider';
import withFetch from '../../hoc/withFetch';
import Heading from '../../components/heading';
import '../monitor/styles.scss';


class DownloadFile extends Component {
    state = {
        isLoading: false
    };

    async downloadFile(e, id, name) {
        e.preventDefault();

        if (!this.props.isAuthenticated) return;

        this.setState({
            isLoading: true
        });

        const res = await this.props.fetch(`${REACT_APP_API_BASE}/online/document/${id}`);
        
        if (res.ok) {
            const blobDocument = await res.blob();
            var blob = new Blob([blobDocument]);
            var link = window.document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = name;
            link.click();

            this.setState({
                isLoading: false
            });
        } else {
            this.setState({
                isLoading: false
            });
        }
    }

    render() {
        return (
            <td>
                <div className={classNames({
                    'file-download': true,
                    'file-download--is-loading': this.state.isLoading
                })}>
                    <button className="table__link" type="button" onClick={(e) => this.downloadFile(e, this.props.document.uuid, this.props.document.name)}>{this.props.document.name}</button>
                    <SpinnerDots />
                </div>
            </td>
        );
    }
}

class MyFiles extends Component {
    
    state = {
        isLoading: true,
        documents: null,
        message: null
    };

    async componentDidUpdate() {
        if (!this.props.isAuthenticated) return;

        if (this.state.documents) return;

        if (this.state.message) return;

        const res = await this.props.fetch(`${REACT_APP_API_BASE}/online/documents`);
        
        if (res.ok) {
            const documents = await res.json();

            this.setState({
                isLoading: false,
                documents
            });
        } else {
            this.setState({
                isLoading: false,
                message: '🔦 Du har inga filer för nedladdning.'
            });
        }
    
    }

    

    render() {
        return (
            <section className={classNames({
                'monitor': true,
                'monitor--is-loading': this.state.isLoading
            })}>
                <Heading heading="Filer" />
                <div className="monitor__table-wrapper">
                    <div className="monitor__table-content">
                        <div className="monitor__content-inner monitor__content-inner--no-padding">
                            <div className="monitor__table-wrapper-inner">
                                {this.state.documents &&
                                    <table className="table">
                                        <thead>
                                            <tr>
                                                <th>FILNAMN</th>
                                                <th>TYP</th>
                                                <th>DATUM</th>
                                                <th>SENAST NEDLADDAD</th>
                                                <th>FORMAT</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.documents.map(document => {
                                                return (
                                                    <tr key={document.uuid}>
                                                        <DownloadFile document={document} isAuthenticated={this.props.isAuthenticated} fetch={this.props.fetch} />
                                                        <td>{document.category}</td>
                                                        <td>{document.date}</td>
                                                        <td>{document.lastDownloadDate}</td>
                                                        <td>{document.fileTypeFormat}</td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                }

                                {this.state.message &&
                                    <p className="monitor__error">{this.state.message}</p>
                                }
                            </div>
                        </div>
                    </div>
                    <SpinnerDots />
                </div>
            </section>
        );
    }
};

export default withAuthProvider(withFetch(MyFiles));